'use strict';

/* jshint ignore:start */
var ROUTE = '/api/talent-signup/';
var THANKS_PATH = '/talentcommunity/thanks';
var FORM_TYPE;

function talentcommunitySubmit(type, isEvents, token) {

  if (isEvents === undefined) {
    isEvents = false;
  }
  FORM_TYPE = type;
  var currentContext = window.currentContextValue;
  var contextOptions = window.talentCommunityIntegration ? window.talentCommunityIntegration.contextOptions : {};
  var fullCurrentContext;
  if (window.contextDefinitions) {
    window.contextDefinitions.some(function (context) {
      if (context.name === currentContext) {
        fullCurrentContext = context;
        return true;
      }
    });
  }
  var data = {};
  if (fullCurrentContext && fullCurrentContext.eventId) {
    isEvents = true;
  }

  $('#talentForm').find('input, textarea, select').each(function (i, field) {
    data[field.name] = field.value;
  });

  if (type === 'jibe') {
    /* Cached List Items */

    var attributes = window.attributes;
    var categories = window.categories;
    var contactMethods = window.contactMethods;
    var contactTimes = window.contactTimes;
    var groups = window.groups;
    var languages = window.languages;
    var phoneTypes = window.phoneTypes;
    var preferredSkills = window.preferredSkills;

    /* Default Input Values */
    var attributesInput = $('#attributesInput').val();
    var categoriesInput = $('#categoriesInput').val();
    var contactMethodsInput = $('#contactMethodsInput').val();
    var contactTimesInput = $('#contactTimesInput').val();
    var groupsInput = $('#groupsInput').val();
    var languagesInput = $('#languagesInput').val();
    var phoneTypesInput = $('#phoneTypesInput').val();
    var phoneInput = $('#phoneInput').val();
    var preferredSkillsInput = $('#preferredSkillsInput').val();
    var skillsInput = $('#skillsInput').val();
    var latestJobCompanyInput = $('#latestJobCompanyInput').val();
    var latestJobTitleInput = $('#lastestJobTitleInput').val();
    var educationSchoolInput = $('#educationSchoolInput').val();
    var educationMajorInput = $('#educationMajorInput').val();
    var educationDegreeInput = $('#educationDegreeInput').val();
    var educationGradInput = $('#educationGradInput').val();

    /* Tags Input Values (Bootstrap) */
    var locationPreferencesInput = null;
    if (document.getElementById("locationPreferencesInput")) {
      locationPreferencesInput = $('#locationPreferencesInput').tagsinput('items');
    }

    /* Checkbox Values */
    var nonCompeteInput = $('#nonCompeteInput').is(':checked');
    var previouslyWorkedInput = $('#previouslyWorkedInput').is(':checked');
    var usEligibilityInput = $('#usEligibilityInput').is(':checked');
    var campaignConsentInput = $('#campaignConsentInput').is(':checked');
    var jobAlertsConsentInput = $('#jobAlertsConsentInput').is(':checked');
    var latestJobCurrentInput = $('#latestJobCurrentInput').is(':checked');
    var latestJobWasHiredInput = $('#latestJobWasHiredInput').is(':checked');
    var educationCurrentInput = $('#educationCurrentInput').is(':checked');
    var consentInputEnabled = $('#generalConsentInput');
    var consentInput = $('#generalConsentInput').is(':checked');

    /* Multiple Inputs Arrays */
    var attributesArray = [];
    var categoriesArray = [];
    var contactMethodsArray = [];
    var contactTimesArray = [];
    var gatewaysArray = [];
    var groupArray = [];
    var languagesArray = [];
    var locationPreferencesArray = [];
    var phonesArray = [];
    var preferredSkillsArray = [];
    var skillsArray = [];
    var employmentHistoryArray = [];
    var educationHistoryArray = [];
    var cellNumberInput = '';
    var homeNumberInput = '';

    /* Multiple Selection Options */
    if (attributesInput && attributesInput.length) {
      attributesArray = attributesInput.reduce(inputReducer(attributes), []);
    }

    if (categoriesInput && categoriesInput.length) {
      categoriesArray = categoriesInput.reduce(inputReducer(categories), []);
    }

    if (groupsInput && groupsInput.length) {
      groupArray = groupsInput.reduce(inputReducer(groups), []);
    }

    if (languagesInput && languagesInput.length) {
      languagesArray = languagesInput.reduce(inputReducer(languages), []);
    }

    if (preferredSkillsInput && preferredSkillsInput.length) {
      preferredSkillsArray = preferredSkillsInput.reduce(inputReducer(preferredSkills), []);
      preferredSkillsArray.forEach((skill) => {
        skill.levelId = "p";
        skillsArray.push(skill);
      })
    }

    /* Single Selection Options */
    if (contactMethods && contactMethods.length) {
      contactMethodsArray = contactMethods.filter(function (cm) {
        return idComparisionCheck(contactMethodsInput, cm.id);
      });
    }

    if (contactTimes && contactTimes.length) {
      contactTimesArray = contactTimes.filter(function (ct) {
        return idComparisionCheck(contactTimesInput, ct.id)
      });
    }

    if (phoneTypes && phoneTypes.length) {
      phoneTypes.forEach(function (p) {
        var phone = {};
        if (phoneTypesInput === p.id) {
          phone.value = phoneInput;
          phone.typeId = p.id;
          phonesArray.push(phone);
          if (phoneTypesInput === 'm') {
            cellNumberInput = phone.value;
          } else {
            homeNumberInput = phone.value;
          }
        }
      });
    }

    /* Employment History */
    if (latestJobCompanyInput || latestJobTitleInput || latestJobCurrentInput) {
      employmentHistoryArray.push({
        current: latestJobCurrentInput,
        companyName: latestJobCompanyInput,
        title: latestJobTitleInput
      });
    }

    /* Education History */
    if (educationSchoolInput || educationDegreeInput || educationGradInput || educationMajorInput || educationCurrentInput) {
      educationHistoryArray.push({
        current: educationCurrentInput,
        schoolName: educationSchoolInput,
        endDate: educationGradInput ? moment(educationGradInput).utc().format() : null,
        major: educationMajorInput,
        degree: educationDegreeInput
      });
    }

    /* Tags Input Options (Bootstrap) */
    if (locationPreferencesInput && locationPreferencesInput.length) {
      locationPreferencesInput.forEach(function (l) {
        var location = {};
        location.name = l;
        locationPreferencesArray.push(location);
      });
    }

    /* All Skills Input Options (Bootstrap) */
    if (skillsInput && skillsInput.length) {
      skillsInput.forEach(function (s) {
        var skills = {};
        skills.name = s;
        skillsArray.push(skills);
      });
    }

    /* Add New Arrays to Data Object */
    /* Multiples */
    data['attributesInput'] = JSON.stringify(attributesArray);
    data['categoriesInput'] = JSON.stringify(categoriesArray);
    data['contactMethodsInput'] = JSON.stringify(contactMethodsArray);
    data['contactTimesInput'] = JSON.stringify(contactTimesArray);
    data['gatewaysInput'] = JSON.stringify(gatewaysArray);
    data['groupsInput'] = JSON.stringify(groupArray);
    data['languagesInput'] = JSON.stringify(languagesArray);
    data['locationPreferencesInput'] = JSON.stringify(locationPreferencesArray);
    data['phoneTypesInput'] = JSON.stringify(phonesArray);
    data['cellNumberInput'] = JSON.stringify(cellNumberInput);
    data['homeNumberInput'] = JSON.stringify(homeNumberInput);

    data['preferredSkillsInput'] = JSON.stringify(preferredSkillsArray);
    data['skillsInput'] = JSON.stringify(skillsArray);
    data['employmentHistory'] = JSON.stringify(employmentHistoryArray);
    data['educationHistory'] = JSON.stringify(educationHistoryArray);
    /* Singles */
    data['previouslyWorkedInput'] = previouslyWorkedInput;
    data['nonCompeteInput'] = nonCompeteInput;
    data['usEligibilityInput'] = usEligibilityInput;
    data['campaignConsentInput'] = campaignConsentInput;
    data['jobAlertsConsentInput'] = jobAlertsConsentInput;
    data['consentInput'] = consentInput;
    data['latestJobWasHiredInput'] = latestJobWasHiredInput;
    if (currentContext && contextOptions && contextOptions.enabled) {
      var options = contextOptions.hasOwnProperty(currentContext) ? contextOptions[currentContext] : null;

      if (options) {
        data['attributesInput'] = JSON.stringify(options.attributes ? [...attributesArray, ...options.attributes] : attributesArray);
        data['groupsInput'] = JSON.stringify(options.groups ? [...groupArray, ...options.groups] : groupArray);
        data['gatewaysInput'] = JSON.stringify(options.gateways ? options.gateways : []);
      }
    }
    if (isEvents) {
      data['eventId'] = fullCurrentContext.eventId;
    }
    data['folderAtsId'] = '';

    //If on a context and welcomeEmail is not set, DO NOT use the angularAppConfig.talentCommunity value
    if (fullCurrentContext && fullCurrentContext['talentcommunity.integration'] && fullCurrentContext['talentcommunity.integration'].welcomeEmail) {
      data['welcome'] = fullCurrentContext['talentcommunity.integration'].welcomeEmail;
    } else if (window.angularAppConfig && window.angularAppConfig.talentCommunity && window.angularAppConfig.talentCommunity.welcomeEmail && !fullCurrentContext) {
      data['welcome'] = window.angularAppConfig.talentCommunity.welcomeEmail;
    }

    if (window.angularAppConfig && window.angularAppConfig.client && window.angularAppConfig.client.login &&
      window.angularAppConfig.client.login.jibeOneLogin && window.angularAppConfig.client.login.jibeOneLogin.altRegister &&
      window.angularAppConfig.client.login.jibeOneLogin.altRegister.folderAtsId) {
      data['folderAtsId'] = window.angularAppConfig.client.login.jibeOneLogin.altRegister.folderAtsId
    }

    if (window.talentCommunityIntegration.restrictedDomains) {
      if (data['emailInput']) {
        var emailDomain = data['emailInput'].split('@')[1];
        var domainMatched = window.talentCommunityIntegration.restrictedDomains.some((email) => {
          return email === emailDomain;
        })

        if (domainMatched) {
          onRestrictedEmailError();
          return;
        }
      }
    }

    if (window.captchaEnabled) {
      data['g-recaptcha-response'] = token;
    }

    // Required Checks
    if (!data['firstNameInput'] || !data['lastNameInput'] || !data['emailInput']) {
      $('.errorMessages').show();
      $('.requiredFieldsErrorMessage').show();

      setTimeout(function () {
        $('.errorMessages').hide();
        $('.requiredFieldsErrorMessage').hide();
      }, 5000);

      return;
    }

    if (consentInputEnabled && !consentInput) {
      $('.errorMessages').show();
      $('.consentErrorMessage').show();

      setTimeout(function () {
        $('.errorMessages').hide();
        $('.consentErrorMessage').hide();
      }, 5000);

      return;
    }

    if (data.jobAlertsConsentInput) {
      onJobAlertsChecked(data, categoriesArray, locationPreferencesArray);
    } else {
      addUserToService(data, isEvents);
    }
  }
  else {
    /* Avature goes straight to addUserToService fn */
    addUserToService(data, false);
  }
}

/**
 * AJAX to post object to our adduser service
 * @param data
 */
function addUserToService(data, isEvents) {

  data['isEvents'] = isEvents;
  $.ajax({
    type: 'POST',
    data: data,
    url: ROUTE + FORM_TYPE,
    dataType: 'JSON',
    success: function (response) {
      var fileInput = document.getElementById('file');
      if (fileInput) {
        var file = document.getElementById('file').files[0];
        /* If user attached a document, send to QS before confirmation redirect */
        if (file && response.user) {
          onAttachDocumentToUser(file, response.user.identifier);
        } else {
          onSuccessResponse();
        }
      } else {
        onSuccessResponse();
      }
    },
    error: function (jqXHR, textStatus, errorThrown) { onErrorResponse(jqXHR, textStatus, errorThrown) }
  });
}

/**
 * AJAX to run if Job Alerts checkbox is selected by candidate
 * @param data
 */
function onJobAlertsChecked(data, categoriesArray, locationsArray) {
  var host = `${window.location.protocol}//${window.location.host}/jobs`;
  var categories = encodeURIComponent(categoriesArray.map(function (obj) {
    return obj.name;
  }));
  var locations = $.param(locationsArray.map(function (_ref) {
    var name = _ref.name;
    return { name: 'location', value: name };
  }));
  var url = `${host}?categories=${categories}&${locations}`;

  var jobAlertsData = {
    email: data.emailInput,
    url
  }

  $.ajax({
    type: 'POST',
    data: jobAlertsData,
    url: '/api/trackif/send',
    success: function () { addUserToService(data) },
    error: function (jqXHR, textStatus, errorThrown) { onErrorResponse(jqXHR, textStatus, errorThrown) }
  });
}

/**
 * Comparision function that is curriable, so if you only provide one argument, it will return a function
 * that will take the second argument.
 * @param value
 * @param id
 * @returns {boolean|(function(*): boolean)}
 */
function idComparisionCheck(value, id) {
  if (arguments.length < 2) {
    return function (innerId) {
      return value === innerId;
    }
  }
  return value === id;
}

/**
 * To be used in a reducer function. Takes in an array of items to be filtered through to find a matching
 * id
 * @param toFilterArray
 * @returns {function(*, *=): *[]}
 */
function inputReducer(toFilterArray) {
  return function (accum, input) {
    return [].concat(_toConsumableArray(accum), _toConsumableArray(toFilterArray.filter(function (item) {
      return idComparisionCheck(parseInt(input) ? parseInt(input) : input, item.id);
    })));
  };
}

/**
 * Vanilla fn in place of spread operator
 * id
 * @param arr
 * @returns {Array}
 */
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}

/**
 * Uploads the user resume
 * @param file
 * @param userId
 */
function onAttachDocumentToUser(file, userId) {
  var formData = new FormData();
  formData.append('file', file);

  $.ajax({
    url: `${ROUTE}attach-document?userId=${userId}&name=${file.name}&process=${false}`,
    method: 'POST',
    data: formData,
    processData: false,
    contentType: false,
    success: function () { onSuccessResponse() },
    error: function (jqXHR, textStatus, errorThrown) { onErrorResponse(jqXHR, textStatus, errorThrown) }
  });
}

/**
 * Redirect to success page
 */
function onSuccessResponse() {
  if (window.currentContextValue) {
    THANKS_PATH = `/${window.currentContextValue + THANKS_PATH}`;
  }
  window.location = THANKS_PATH;
}

/**
 * On error response
 * @param jqXHR
 * @param textStatus
 * @param errorThrown
 */
function onErrorResponse(jqXHR, textStatus, errorThrown) {
  console.log('Talent Community Error', jqXHR, textStatus, errorThrown);
  var errorCode = null;
  if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.err &&
    jqXHR.responseJSON.err.client4xx && jqXHR.responseJSON.err.client4xx.error &&
    jqXHR.responseJSON.err.client4xx.error.errors &&
    jqXHR.responseJSON.err.client4xx.error.errors[0] &&
    jqXHR.responseJSON.err.client4xx.error.errors[0].code)
  {
    errorCode = jqXHR.responseJSON.err.client4xx.error.errors[0].code;
  }

  var tokens = window.i18n.DEFAULT_TRANSLATIONS.TALENT_COMMUNITY;
  var errorMessage = "";

  if (tokens['SIGNUP_ERROR'] && tokens['SIGNUP_ERROR'][errorCode]) {
    errorMessage = tokens['SIGNUP_ERROR'][errorCode];
  }

  $('.errorMessages').show();

  if (errorMessage) {
    $('.specificErrorMessage').text(errorMessage);
    $('.specificErrorMessage').show();
  } else {
    $('.genericErrorMessage').show();
  }

  setTimeout(function () {
    $('.errorMessages').hide();
    $('.specificErrorMessage').hide();
    $('.genericErrorMessage').hide();
  }, 5000);
}

function onRestrictedEmailError() {
  $('.restrictedEmailMessage').show();

  setTimeout(function () {
    $('.restrictedEmailMessage').hide();
  }, 5000);
}

/**
 * Searches Skills list on user input
 * @param skill
 */
function onSkillsSearch(skill, select) {
  if (skill !== '') {
    $.ajax({
      url: `${ROUTE}skills-search?&name=${skill}`,
      method: 'POST',
      processData: false,
      contentType: false,
      success: function (data) {
        for (var i = 0; i < data.length; i++) {
          if (!select.find('option#' + data[i].id).length) {
            select.append(
              '<option id=' + data[i].id + ' value="' + data[i].name + '">' + data[i].name + '</option>'
            );
          }
        }
      },
      error: function (jqXHR, textStatus, errorThrown) { onErrorResponse(jqXHR, textStatus, errorThrown) }
    });
  }
}

$(document).on('keyup', '#allSkills .select2-search__field', function (e) {
  var skillsSelectBox = $('#skillsInput');
  var searchValue = e.currentTarget.value;
  onSkillsSearch(searchValue, skillsSelectBox);
});

function validateCaptchaForm(token) {
  talentcommunitySubmit('jibe', null, token);
}

/* jshint ignore:end */
